import * as React from 'react'
// components
import Row from './components/Row'
// view components
import { Table } from 'components/UI'
// constants
// context
import { ActionsPageContext } from 'containers/Actions/Register/layers/API'
import { TableManagementContext } from 'containers/Search/layers/BL'
// utils
import { getTableHeader } from 'utils/index'

const ActionsTable: React.FC = () => {
  const { data, fields, refetch, totalCount, isRefetching } = React.useContext(ActionsPageContext)
  const { handleSetPage, handleSetPerPage, page, perPage } = React.useContext(TableManagementContext)

  const headers = [
    {
      id: 'entity.description',
      sortable: true,
      left: true,
      label: getTableHeader('description', fields, 'DESCRIPTION')
    },
    { id: 'status', sortable: false, left: true, label: getTableHeader('status', fields, 'STATUS') },
    { id: 'associatedWith', sortable: false, left: true, label: 'ASSOCIATED WITH' },
    { id: 'actionDue', sortable: false, left: true, label: 'ACTION DUE' },
    { id: 'nextReview', sortable: false, left: true, label: 'NEXT REVIEW' },
    {
      id: 'ownedBy',
      sortable: false,
      left: true,
      label: getTableHeader('ownedByEmployeeOrPosition', fields, 'OWNED BY')
    }
  ]

  return (
    <Table
      data={data}
      page={page}
      title='Actions'
      headers={headers}
      perPage={perPage}
      refetch={refetch}
      totalCount={totalCount}
      isLoading={isRefetching}
      onPageChange={handleSetPage}
      onPerPageChange={handleSetPerPage}>
      {({ data }) => data.map((item) => <Row key={item.id} data={item} fields={fields} />)}
    </Table>
  )
}

export default ActionsTable
